class AccessControl {
  constructor(api) {
    this.api = api;
  }

  getAllRoles(fields, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/accesscontrol/roles?paginate=false&include=" + fields)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getRoleByID(id, fields, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/accesscontrol/roles" + id + "?include=" + fields)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getAllPermissions(fields, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/accesscontrol/permissions?paginate=false&include=" + fields)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getPermissionByID(id, fields, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/accesscontrol/permissions/" + id + "?include=" + fields)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getPermissionsMatrix(companyID, roleID, onSuccess, onError) {
    let filters = "";
    if (roleID) {
      filters += "?role=" + roleID;
    }
    return this.api.http_fibercloud
      .get("v1/accesscontrol/permissions/map/" + companyID + "/" + filters)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}

export default AccessControl;



// WEBPACK FOOTER //
// ./src/api/accessControl.js